import { on } from 'delegated-events'
import { handleValidation } from '../common/validation'

const form = document.querySelector('.donation-form')
const totalField = form ? form.querySelector('#donate-total-field') : null
const submitButton = form ? form.querySelector('[name=action_submit]') : null
const cardElement = document.getElementById('card-element')

const state = {
  stripe: null,
  stripeCard: null,
}

const fn = {
  init: () => {
    fn.setupAmount()
    fn.setupPayment()
  },

  setupAmount: () => {
    const slider = form.querySelector('input[type=range]')
    const marks = form.querySelector('.marks')
    const amountField = form.querySelector('input.donation-amount-field')
    const options = JSON.parse(form.querySelector('#amount-options').textContent)

    const setAmount = (amount) => {
      amountField.value = `$${amount}.00`

      fn.setTotal(amount)
    }

    const selectedValueIndex = options.indexOf(parseInt(amountField.value.replace('.00', '').replace('$', '')))

    if (selectedValueIndex >= 0) {
      slider.value = selectedValueIndex
    }

    options.forEach((opt, i) => {
      const activeClass = parseInt(slider.value) === i ? 'is-active' : ''

      const mark = document.createRange().createContextualFragment(`
        <div class="mark ${activeClass}" data-index="${i}">
          $${opt}
        </div>
      `)

      marks.appendChild(mark)
    })

    slider.addEventListener('input', (e) => {
      const index = e.target.value
      marks.querySelector('.is-active').classList.remove('is-active')
      marks.querySelector(`[data-index="${index}"]`).classList.add('is-active')

      setAmount(options[index])
    })

    on('change', 'input.donation-amount-field', (e) => {
      const value = e.target.value.replace('.00', '').replace('$', '')

      fn.setTotal(value)
    })

    on('change', 'input[name=RepeatDonation]', (e) => {
      const durationField = form.querySelector('.duration-holder')

      if (e.target.checked) {
        durationField.classList.remove('hidden')
      } else {
        durationField.classList.add('hidden')
      }
    })
  },

  setTotal: (amount) => {
    totalField.textContent = `$${amount}`
  },

  setupPayment: () => {
    if (cardElement) {
      state.stripe = window.Stripe(form.dataset.stripePubKey)
      state.isRepeating = form.querySelector('[type=hidden][name=IsRepeating]')
      fn.setupStripeCard()

      form.addEventListener('submit', fn.handleSubmit)

      on('click', '[formnovalidate]', () => {
        form.skipValidation = true
      })
    }
  },

  setupStripeCard: () => {
    const style = {
      base: {
        fontSize: '16px',
        fontFamily: 'Poppins, sans-serif',
        color: '#2c2c2c',
        fontSmoothing: 'antialiased',
        '::placeholder': {
          color: '#b4b4b4',
        },
      },
      invalid: {
        color: '#b9112a',
      },
    }

    const card = state.stripe.elements().create('card', { style })

    card.mount('#card-element')
    state.stripeCard = card

    card.addEventListener('change', ({ error }) => {
      const displayError = document.getElementById('card-errors')
      if (error) {
        displayError.textContent = error.message
      } else {
        displayError.textContent = ''
      }
    })
  },

  handleSubmit: (e) => {
    if (e.target.skipValidation || e.target.forceSubmit) {
      return true
    }

    e.preventDefault()

    const isValid = handleValidation(e.target)

    if (!isValid) {
      return
    }

    // Handle Stripe
    submitButton.disabled = true
    submitButton.classList.add('btn-loading')

    state.stripe
      .createToken(state.stripeCard, {
        name: form.querySelector('[name=CardholderName]').value,
      })
      .then((result) => {
        if (result.error) {
          const errorElement = document.getElementById('card-errors')
          errorElement.textContent = result.error.message
          submitButton.disabled = false
        } else {
          fn.stripeTokenHandler(result.token)
        }
      })

    return false
  },

  stripeTokenHandler: (token) => {
    const formMessages = form.querySelector('.form-messages')
    const hiddenInput = document.createElement('input')
    hiddenInput.setAttribute('type', 'hidden')
    hiddenInput.setAttribute('name', 'stripeToken')
    hiddenInput.setAttribute('value', token.id)
    form.appendChild(hiddenInput)

    submitButton.disabled = true

    ajax
      .url(form.action)
      .body(new FormData(form))
      .post()
      .json((res) => {
        if (res.success) {
          form.querySelectorAll('.form-content').forEach((x) => x.classList.add('hidden'))
        }

        if (res.message) {
          fn.showFormMessages(formMessages, res.message, res.success, false)
        }
      })
      .catch(() => {
        fn.showFormMessages(formMessages, 'Sorry, there was a problem with your submission')
      })
      .finally(() => {
        submitButton.disabled = false
      })
  },

  showFormMessages: (holder, message, success, autoHide) => {
    holder.style.display = 'block'
    holder.innerHTML = message

    if (success) {
      holder.classList.remove('form-message-error')
    } else {
      holder.classList.add('form-message-error')
    }

    if (autoHide) {
      setTimeout(() => {
        holder.style.display = 'none'
      }, 5000)
    }
  },
}

export default {
  can: () => document.body.classList.contains('pagetype-donatepage'),
  run: fn.init,
}
